import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Styled } from 'app/features/pricingPromo/landing/components/megaFanPerks/perks/components/Perk.styled';
import Text from 'app/components/layout/Text.styled';

const AdFreeAnime = () => (
  <Styled.Perk data-t="add-free-perk">
    <Styled.PerkIcon
      role="img"
      color="--colors-orange-base"
      viewBox="0 0 40 40"
    >
      <path d="M20 28a6 6 0 110 12 6 6 0 010-12zm0 3a3 3 0 100 6 3 3 0 000-6zm0-31a4.999 4.999 0 014.995 4.783L25 5v16c0 2.873-2.068 5-5 5-2.855 0-4.89-1.83-4.996-4.76L15 21V5a5 5 0 015-5zm0 3a2.001 2.001 0 00-1.995 1.85L18 5v16c0 1.351.662 2 2 2 1.192 0 1.93-.69 1.995-1.834L22 21V5a2 2 0 00-2-2z" />
    </Styled.PerkIcon>
    <Text as={Styled.PerkDescription} size="l">
      <FormattedMessage id="pricing_promo_landing_perks_add_free" />
    </Text>
  </Styled.Perk>
);

AdFreeAnime.displayName = 'AdFreeAnime';

export default AdFreeAnime;
